import { $, $$ } from './_queryselector.js';
import * as _ from './_helpers.js';
import * as Scroll from './_scroll.js';
import scrollMonitor from './_scroll_monitor.js';
import shave from '../../bower_components/shave/dist/shave.js';

export let initialized = false;

let width;
let grid;
let boxes;
let container;
const resizeHandler = _.throttle(layout, 250);

export function init(cont, itemSelector) {

    if (initialized) {
        layout();
        return;
    }

    initialized = true;

    container = cont;

    boxes = $$(itemSelector, container);
    container.style.position = 'relative';

    layout();

    window.addEventListener('resize', resizeHandler);

}

export function destroy() {
    initialized = false;
    window.removeEventListener('resize', resizeHandler);
}

export function layout(items) {
    if (typeof items !== 'undefined' && typeof items.length === 'number') {
        boxes = items;
    }

    let w1 = container.querySelector('.grid-item--w1:not(.js-grid-spacer)');
    let w2 = container.querySelector('.grid-item--w2');
    if (w1) {
        width = w1.offsetWidth;
    } else {
        width = w2.offsetWidth / 2;
    }

    if (_.windowWidth < 600) {
        for (let j = 0; j < boxes.length; j++) {
            boxes[j].style.position = boxes[j].style.top = boxes[j].style.left = '';
        }
        container.style.height = '';

        truncateContent();

        return;
    }

    const colCount = (_.windowWidth < 1100) ? 2 : 3;

    grid = [];

    for (let i = 0; i < 100; i++) {
        grid.push(Array.apply(null, Array(colCount)).map(Number.prototype.valueOf, 0));
    }

    for (let i = 0; i < boxes.length; i++) {
        const box = boxes[i];

        if (colCount === 2 && box.classList.contains('js-grid-spacer')) {
            continue;
        }

        const size = box.classList.contains('grid-item--w1') ? '1' : '2';
        let done = false;

        grid.some((el1, row) => {
            if (done) return true;
            el1.some((el2, col) => {
                if (size === '1' && canFit1(row, col)) {
                    grid[row][col] = 1;
                    done = true;
                    position(box, row, col);
                    return true;
                } else if (size === '2' && canFit2(row, col)) {
                    grid[row][col] = 1;
                    grid[row][col + 1] = 1;
                    grid[row + 1][col] = 1;
                    grid[row + 1][col + 1] = 1;
                    done = true;
                    position(box, row, col);
                    return true;
                }
            });
        });
    }

    let rowCount = 0;
    grid.some(row => {
        const empty = Array.apply(null, Array(colCount)).map(Number.prototype.valueOf, 0);
        const isSame = (row.length == empty.length) && row.every(function(element, index) {
            return element === empty[index];
        });
        if (!isSame) {
            rowCount++;
        } else {
            return true;
        }
    });
    container.style.height = (rowCount * width) + 'px';

    // recalc top position of grid items
    scrollMonitor.recalculateLocations();
    setTimeout(Scroll.recalcBackgroundSections, 1000);

    truncateContent();
}

function canFit1(row, col) {
    return grid[row][col] === 0;
}

function canFit2(row, col) {
    if (col === 3) return false;
    return (
        grid[row][col] === 0 &&
        grid[row][col + 1] === 0 &&
        grid[row + 1][col] === 0 &&
        grid[row + 1][col + 1] === 0
    );
}

function position(box, row, col) {
    const top = row * width;

    box.style.position = 'absolute';
    box.style.top = `${top}px`;
    box.style.left = (col * width) + 'px';

    if ((parallax.pageName === 'news_articles_index' || parallax.pageName === 'careers_index' || parallax.pageName === 'events_index') && top === 0) {
        box.classList.remove('fade-up', 'js-in-view');
        box.classList.add('fade-up-immediate');
    }
}

function truncateContent() {
    shave('.js-grid-truncate', width * 0.4);

    requestAnimationFrame(() => {
        const els = document.querySelectorAll('.js-grid-truncate');
        for (let i = 0; i < els.length; i++) {
            els[i].classList.remove('js-grid-truncate');
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/components/_grid.js